export const PRODUCTS_CACHE_VERSION = "v6";

export const getProductsCacheKey = (supplierId, page, search, category, subcategory = "", hasFootprint = "", needsData = "") => {
  return `products_cache_${PRODUCTS_CACHE_VERSION}_${supplierId}_${page}_${search}_${category}_${subcategory}_${hasFootprint}_${needsData}`;
};

export const clearSupplierCache = (supplierId) => {
  if (!supplierId) return;

  try {
    const prefix = `products_cache_${PRODUCTS_CACHE_VERSION}_${supplierId}_`;
    const categoriesKey = `categories_cache_${supplierId}`;
    const promoCategoriesKey = `promo_categories_cache_${supplierId}`;

    sessionStorage.removeItem(categoriesKey);
    sessionStorage.removeItem(promoCategoriesKey);

    const keysToRemove = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(prefix)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch (err) {
    console.warn("Error clearing supplier cache:", err);
  }
};
